const APPS = {
  'gifts-card-edit': {
    elementId: 'js-gifts-card-edit-app'
  },
  'education-materials': {
    elementId: 'js-education-materials-app'
  },
  'gifts-admin': {
    elementId: 'js-gifts-admin-app'
  }
  // Enable if needed
  // 'donor-service': {
  //  elementId: 'js-donor-service-app'
  // }
}

/**
 * Lazy load Vue app if it's needed on current page and run it
 *
 * @async
 * @param {string} appName - Name of Vue app
 * @return {Object} return app or null if app is not needed on this page
 */
export async function importVueApp(appName) {
  const data = APPS[appName];
  if (!data) {
    throw Error(`Vue app '${appName}' not found`);
  }

  const element = document.getElementById(data.elementId);
  if (!element) {
    return Promise.resolve(null);
  }

  // Show a spinner as this might take a while with limited bandwidth
  element.classList.add('loader');

  /**
   * Run vue app
   *
   * @param {Object} app - App
   * @return {Object} App
   */
  function runApp(app) {
    // Vue replaces whole element, but remove loader class just in case
    element.classList.remove('loader');
    app.init(data.elementId);
    return app;
  }

  switch(appName) {
  case 'gifts-card-edit':
    return import('./apps/gifts-card-edit').then(({ app }) => runApp(app));
  case 'education-materials':
    return import('./apps/education-materials').then(({ app }) => runApp(app));
  case 'gifts-admin':
    return import('./apps/gifts-admin').then(({ app }) => runApp(app));
  // Enable if needed
  // case 'donor-service':
  //   return import('./apps/donor-service').then(({ app }) => runApp(app));
  }
}
